import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.lg}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
